/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordstrengthstrong2Inputs */

const en_passwordstrengthstrong2 = /** @type {(inputs: Passwordstrengthstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const de_passwordstrengthstrong2 = /** @type {(inputs: Passwordstrengthstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stark`)
};

/**
* | output |
* | --- |
* | "Strong" |
*
* @param {Passwordstrengthstrong2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordstrengthstrong2 = /** @type {((inputs?: Passwordstrengthstrong2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordstrengthstrong2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordstrengthstrong2(inputs)
	return de_passwordstrengthstrong2(inputs)
});
export { passwordstrengthstrong2 as "passwordStrengthStrong" }